import { render } from "./KanbanColumn.vue?vue&type=template&id=64553f62&scoped=true"
import script from "./KanbanColumn.vue?vue&type=script&lang=js"
export * from "./KanbanColumn.vue?vue&type=script&lang=js"

import "./KanbanColumn.vue?vue&type=style&index=0&id=64553f62&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64553f62"]])

export default __exports__